import React, { useEffect, useState } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import useInstallation from '../hooks/use-installation'
import { isUndefined } from 'lodash'
import { BlankViewImageVariants, BlankView } from 'src/Components/blank-view'
import { useDispatch } from 'react-redux'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { Loading } from '@e3dc-react/shell/Elements/Loading'
import { resetActiveValues } from 'src/State/Storage/StorageActions'
import { getInstallationDashboardUrlByIds } from 'src/Libs/dashboard/routes'

/**
 *  This component redirects the user to an installation Dashboard for the given serialnumber (deviceId)
 */
const InstallationRedirect: React.FC = () => {
  const { t, selectedAppLanguage } = useCustomTranslation()
  const navigate = useNavigate()
  const { search } = useLocation()
  const queryStorageId = new URLSearchParams(search).get('serialno')
  const { storageId: paramStorageId } = useParams<{ storageId: string }>()
  const storageId = paramStorageId || queryStorageId
  const { getInstallationBySerialNumber } = useInstallation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [appTitleKey, setAppTitleKey] = useState('installation.redirect.app-loading-title')

  useEffect(() => {
    if (isUndefined(storageId)) {
      setLoading(false)
      return
    }

    getInstallationBySerialNumber(parseInt(storageId as string))
      .then(installation => {
        if (isUndefined(installation)) {
          setAppTitleKey('installation.redirect.app-title')
          return
        }

        navigate(`${getInstallationDashboardUrlByIds(installation.id, storageId)}`)
      })
      .catch(e => {
        setAppTitleKey('installation.redirect.app-title')
        console.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageId])

  useEffect(() => {
    dispatch(appUpdate({ title: t(appTitleKey) }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appTitleKey, dispatch, selectedAppLanguage])

  useEffect(() => {
    dispatch(resetActiveValues())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading && <Loading />}
      <BlankView
        imageVariant={loading ? BlankViewImageVariants.Neutral : BlankViewImageVariants.Worried}
        title={loading ? 'installation.redirect.loading-title' : 'installation.redirect.title'}
        explanation={loading ? 'installation.redirect.loading-explanation' : 'installation.redirect.explanation'}
        action={{ text: 'common.back', onClick: () => navigate('/') }}
      />
    </>
  )
}

export default InstallationRedirect
